<template>
  <div id="fonte-sincronizador-c">
    <p
      :class="
        fonteSincronizadorC.qtdDiasUltimaAtualizacao > 3 ? 'font-color-red' : ''
      "
    >
      <b>Fonte:</b>
      {{ ' e-SUS, ' + fonteSincronizadorC.ultimaAtualizacao }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    texto: {
      type: String,
      default: '',
    },
    data: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  computed: {
    fonteSincronizadorC() {
      if (this.$store.getters['getSincronizadorC'] !== null) {
        return this.$store.getters['getSincronizadorC']
      }
      return null
    },
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
#fonte-sincronizador-c {
  margin-bottom: 10px;
  .font-color-red {
    color: red;
    background: none;
  }
  p {
    margin-bottom: 0;
  }
}
</style>
